<template>
  <div>
    <modal
      :size="'modal-small'"
      :close-strict="true"
      @close="$emit('close')"
    >
      <div slot="header">
        <div class="row">
          <div class="col-10">
            <h4 v-if="settlementAmount.type.name === 'Office'">Deny request for office price</h4>
            <h4 v-if="settlementAmount.type.name === 'Subco'">Deny request for subco price</h4>
          </div>
        </div>
      </div>
      <div slot="body">
        <div class="row mb-2">
          <div class="col">
            <div class="select-wrap h-auto">
              <label>Reason for denying price</label>
              <textarea
                v-model="settlementAmount.note"
                cols="30"
                rows="5"
                class="select-wrap-textarea form-control"
                placeholder="Enter reason for denying price"
              />
            </div>
            <error-field :errors="errors" field="note" />
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="row mb-2 mt-4">
          <div class="col text-center">
            <button type="button" class="btn btn-secondary" @click="$emit('close')">
              Cancel
            </button>
            <button class="btn btn-danger ld-text-right"
                    :class="loadingButton ? 'running' : ''"
                    :disabled="buttonDisabled"
                    type="button"
                    @click="updateStatus(4)"
            >
              Deny price request
              <div v-if="loadingButton" class="ld ld-ball ld-flip" />
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from '../../Modal';
import ErrorField from '../../ErrorField';

export default {
  components: {
    Modal,
    ErrorField,
  },
  props: {
    errors: {
      type: Object,
      default: () => {},
    },
    settlementAmount: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    loadingButton: false,
    buttonDisabled: false,
  }),
  methods: {
    updateStatus() {
      this.$emit('update');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/claims/Modals/DeclineSettlementAmount.vue